<template>
    <div>
        <h3 class="text-center"
            v-text="jsonObjectAboutUs.secGeneral.geEquFed"></h3>
        <ul>
            <li v-for="info in jsonObjectAboutUs.address"
                v-html="info.contact"></li>
        </ul>

        <ul>
            <li v-for="info in jsonObjectAboutUs.secGeneral"
                v-html="info.name1"></li>
        </ul>

        <ul>
            <li v-for="info in jsonObjectAboutUs.president"
                v-html="info.presidentName"></li>
        </ul>

        <ul>
            <li v-for="info in jsonObjectAboutUs.vicPres"
                v-html="info.vicPresName"></li>
        </ul>

    </div>
</template>

<script>
import jsonObjectAboutUs from './AboutUsJSON/en-AboutUs.json';
export default {
 data(){
     return{
         jsonObjectAboutUs,
     }
 }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/EN-vers/menu/AboutUs.vue